import PayOrderDataStore from '@/data/datastores/PayOrderDataStore';
import apiClient from './apiClient';
import { payOrderRequest as schemaPayOrderRequest } from './schemas';

class PayOrderDataStoreGraphQL implements PayOrderDataStore {
  client = apiClient();

  async register(
    code: string,
    orderId: string,
    transactionId: string,
    email: string,
    payMethod: string,
    brand: string,
    message: string
  ) {
    try {
      const response = await this.client.mutate({
        mutation: schemaPayOrderRequest.payOrder,
        variables: {
          code,
          orderId,
          transactionId,
          email,
          payMethod,
          brand,
          message
        }
      });
      const { data } = response;
      return data?.payOrder;
    } catch (error) {
      throw new Error('error paying order');
    }
  }
}

export default PayOrderDataStoreGraphQL;
